const addSpacesToIBAN = (iban: string): string =>
    iban
        .replace(/[^\dA-Z]/g, '')
        .replace(/(.{4})/g, '$1 ')
        .trim();

export {addSpacesToIBAN};
